export var SUBSCRIPTION_SUCCESS_EVENT = 'pusher:subscription_succeeded';
export var SUBSCRIPTION_ERROR_EVENT = 'pusher:subscription_error';
export var MEMBER_ADDED_EVENT = 'pusher:member_added';
export var MEMBER_REMOVED_EVENT = 'pusher:member_removed';